import {useEffect, useState} from 'react';

export default (url: string) => {
  const [data, setData] = useState<any>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<Error | null>(null);
  const update = () => {
    setLoading(true);
    fetch(url)
      .then((res) => {
        try {
          if (res.status === 200) {
            return res.json();
          }
          throw new Error(`Unable to Fetch from ${url}`);
        } catch (e) {
          throw new Error(`Unable to Fetch from ${url}`);
        }
      })
      .then((res) => {
        setData(res);
        setLoading(false);
      })
      .catch((err) => {
        setError(err);
        setLoading(false);
      });
  };
  useEffect(update, [url]);
  return {data, loading, error, update};
};
